import httpClient from "../http/http-client";
import { IPcfFigures, IPcfGenerateResponse, IPcfReport } from './pcf-report.model';

export default class PcfReportService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(finishedProductId?: string): Promise<IPcfReport[]> {
    return this.http.get(`pcf-report${finishedProductId ? `?finishedProductId=${finishedProductId}` : ''}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getOne(id: string): Promise<IPcfReport> {
    return this.http.get(`pcf-report/${id}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async create(finishedProductId: string, reportPeriodId: string | null): Promise<IPcfReport> {
    return this.http.post('pcf-report', { finishedProductId, reportPeriodId: reportPeriodId || null })
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async update(id: string, details: Partial<IPcfReport>): Promise<IPcfReport> {
    // '' in a Postgres date column is an error rather than an empty value.
    const payload: Record<string, any> = { ...details }
    for (const field of ['publicationDate', 'signOffDate']) {
      if (payload[field] === '') payload[field] = null
    }
    return this.http.patch(`pcf-report/${id}`, payload)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async getFigures(id: string): Promise<IPcfFigures> {
    return this.http.get(`pcf-report/${id}/figures`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async generate(id: string): Promise<IPcfGenerateResponse> {
    return this.http.post(`pcf-report/${id}/generate`, {})
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }
}
